module.exports = __webpack_public_path__ + "static/media/icon-moveup.3ead8dd6.svg";